import { render, staticRenderFns } from "./TabRealisasi.vue?vue&type=template&id=5e4432f4&"
import script from "./TabRealisasi.vue?vue&type=script&lang=js&"
export * from "./TabRealisasi.vue?vue&type=script&lang=js&"
import style0 from "./TabRealisasi.vue?vue&type=style&index=0&id=5e4432f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports